<template>
  <v-container
    fluid
    fill-height
    style="padding: 0; margin: 0"
    class="gradient-bg"
  >
    <v-snackbar top color="error" v-model="snackbar.model">{{
      snackbar.msg
    }}</v-snackbar>

    <v-row style="height: 100%" no-gutters>
      <v-col cols="12">
        <v-row justify="center" no-gutters>
          <v-col cols="12" class="mx-auto d-flex justify-center mt-12 mb-6">
            <div>
              <Logo :width="180" :filename="`logo-white.svg`" />
            </div>
          </v-col>

          <v-col cols="12" md="5">
            <v-card style="width: 90%" class="mx-auto pa-8 elevation-0">
              <v-list-item class="text-center">
                <v-list-item-content>
                  <v-list-item-title class="mb-3">
                    <h2 style="color: #1b3665">Log In</h2>
                  </v-list-item-title>
                  <p>Please log in to vote...</p>
                </v-list-item-content>
              </v-list-item>

              <v-form v-model="valid" ref="form" @submit.prevent="login">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      placeholder="email or phone number"
                      v-bind="fieldProps2"
                      v-model="form.username"
                      :rules="[rules.required, rules.username]"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      placeholder="password"
                      v-bind="fieldProps2"
                      v-model="form.password"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      v-on:click:append="show = !show"
                      :type="show ? 'text' : 'password'"
                      :rules="[rules.required, rules.password.min]"
                    ></v-text-field>
                    <div cols="12" class="d-flex flex-row-reverse mt-1">
                      <router-link
                        :to="{ name: 'Forgot' }"
                        style="text-decoration: underline"
                        >Forgot Password</router-link
                      >
                    </div>
                  </v-col>

                  <v-col cols="12" class="mt-6">
                    <v-btn
                      :loading="loading"
                      :disabled="loading"
                      type="submit"
                      v-bind="btnProps2"
                      class="primary"
                      block
                      >Log in</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  rules,
  fieldProps2,
  btnProps2,
  labelProps,
  toSentenceCase,
} from "@/helpers";
import { mapActions } from "vuex";
import Logo from "@/components/Logo.vue";
import router from "../../router";

export default {
  components: {
    Logo,
  },

  data: () => ({
    rules,
    fieldProps2,
    btnProps2,
    labelProps,

    snackbar: {
      model: false,
      msg: "Error!",
    },

    form: {
      username: "",
      password: "",
    },

    loading: false,
    show: false,
    valid: true,
  }),

  computed: {
    brandName() {
      return process.env.VUE_APP_BRAND_NAME;
    },
  },

  methods: {
    ...mapActions(["userAuth", "makeFetch"]),

    showSnackbar(event) {
      this.snackbar.msg = toSentenceCase(event.msg);
      this.snackbar.model = true;
    },

    async login() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      // check if user is using email or phone number to login
      const { username, password } = this.form;
      const data = { password: password, login_type: "voter" };

      const isEmail = rules.email(username);
      isEmail == true
        ? (data["email"] = username.trim())
        : (data["phone_number"] = username);

      const isLoggedIn = await this.userAuth({ ...data })
        .then((res) => {
          if (res.message) {
            this.showSnackbar({ msg: res.message });
            return false;
          }
          return res;
        })
        .catch((err) => {
          console.error(err.message);
          this.showSnackbar({ msg: "Connection error!" });
        });

      if (isLoggedIn) {
        // get polls
        const res = await this.makeFetch({
          method: "get",
          goTo: "/polls",
          stateVar: "polls",
        }).catch((err) => {
          console.error(err.message);
          this.showSnackbar({ msg: "Connection error!" });
        });

        if (res) {
          const storedId = localStorage.getItem("pid");

          if (res.data.length > 0)
            router.push({
              name: "VotePage",
              params: { id: storedId ? storedId : res.data[0].id },
            });
          else {
            localStorage.clear();
            this.showSnackbar({
              msg: "Sorry, you have no polls available.",
            });
          }
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.gradient-bg {
  background-image: linear-gradient(#005cff, #2d9bfc, #3de0ff);
  background-size: cover;
}
</style>
